import { Logtail } from '@logtail/browser';
import { BETTERSTACK_LOGTAIL_HOST, BETTERSTACK_SECURE_TOKEN } from '@/store/constants';

let logtail = null;

if (BETTERSTACK_SECURE_TOKEN && BETTERSTACK_LOGTAIL_HOST) {
    logtail = new Logtail(BETTERSTACK_SECURE_TOKEN, {
        endpoint: BETTERSTACK_LOGTAIL_HOST,
    });
}

export default {
    install(app) {
        app.config.globalProperties.$logtail = logtail;
    },
};

export { logtail };
